import React, { useEffect } from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { TOKEN_NAMES } from "../../../store/global/TokenEnum";
import { Amount } from "../../../types/amount";
import OrderInProgressGif from "../../../img/trade-interface/order_in_progress.gif";
import { RandomMessage } from "../../../components/RandomMessage/RandomMessage";
import { ReviewAmountLabel } from "./ReviewAmountLabel";
import { getTokenIcon } from "../../../utils/tokenIconUtils";
import { Text } from "../../../components/general/Text";
import { WrapProps } from "../Wrap";

export const WrapInProgress: React.FC<WrapProps> = ({ takerToken, makerToken }) => {
  const wrapQuote = GlobalStore.useState(s => s.wrapQuote);
  const tokens = GlobalStore.useState(s => s.tokens);
  const theme = GlobalStore.useState(s => s.theme);
  const formattedAmount = wrapQuote?.amount?.value.toDP(5).toString();
  const getUsdValue = () => {
    if (tokens && wrapQuote && wrapQuote.amount) {
      const tokenWithUsdPrice =
        tokens[makerToken] === undefined ? tokens[takerToken] : tokens[makerToken];
      return tokenWithUsdPrice?.priceUsd.value.mul(Number(formattedAmount)).toFixed(2);
    }
    return Amount.ZERO.formatted;
  };

  useEffect(() => {
    // Close Confirm Trade modal
    GlobalStore.update(s => {
      s.modalSelector = undefined;
    });
  }, []);

  return (
    <div className="review-order">
      <div className="sp10"></div>
      <div className="col-12 text-center">
        <img src={OrderInProgressGif} width={115} height={116} alt="Order is in progress" />
        <div className="sp12"></div>
        <RandomMessage />
      </div>
      <div className="sp12"></div>
      <div>
        <div className="review-pay br-14">
          <p className="trade-box-header">You're Paying</p>
          <div className="d-flex justify-content-between">
            <Text textStyle="Paragraph" size="XL" color={theme.font.primary.default}>
              <img
                width="32"
                height="32"
                src={getTokenIcon(takerToken, tokens)}
                alt={takerToken}
                className="me-2"
              />
              {TOKEN_NAMES[takerToken]}
            </Text>
            <div className="d-flex flex-column align-items-end">
              <div>
                <ReviewAmountLabel
                  formattedAmount={formattedAmount ?? ""}
                  tokenTicker={takerToken}
                />
              </div>
              <span className="pay-review-usd">${getUsdValue()}</span>
            </div>
          </div>
        </div>
        <div className="sp10"></div>
        <div className="review-pay br-14">
          <p className="trade-box-header">You're Receiving</p>
          <div className="d-flex justify-content-between">
            <Text textStyle="Paragraph" size="XL" color={theme.font.primary.default}>
              <img
                width="32"
                height="32"
                src={getTokenIcon(makerToken, tokens)}
                alt={makerToken}
                className="me-2"
              />
              {TOKEN_NAMES[makerToken]}
            </Text>
            <div className="d-flex flex-column align-items-end">
              <div>
                <ReviewAmountLabel
                  formattedAmount={formattedAmount ?? ""}
                  tokenTicker={makerToken}
                />
              </div>
              <span className="pay-review-usd">${getUsdValue()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
